<template>
  <div class="hospital-send">
    <!-- 搜索条件 -->
    <div class="hospital-send-search">
      <el-form
        ref="hospitalSendFormRef"
        :inline="true"
        :model="hospitalSendForm"
        class="demo-form-inline"
      >
        <el-form-item label="统计时间">
          <el-date-picker
            v-model="hospitalSendForm.statistics_time"
            clearable
            type="daterange"
            unlink-panels
            range-separator="到"
            end-placeholder="结束日期"
            start-placeholder="开始日期"
            size="small"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="searchBtn">
            查询<i class="el-icon-search el-icon--right" />
          </el-button>

          <!-- 导出 -->
          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('2075') : false
            "
            @click="exportData"
          >
            导出<i class="el-icon-download el-icon--right" />
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 概括 -->
    <div class="data-info">
      <div class="item">
        <span>处方总数：</span>
        <span>{{ statistics_info.all_order_count || 0 }}</span>
      </div>
      <div class="item">
        <span>处方发货总数：</span>
        <span>{{ statistics_info.all_send_count || 0 }}</span>
      </div>
      <div class="item">
        <span>商城订单总数：</span>
        <span>{{ statistics_info.shop_order_count || 0 }}</span>
      </div>
      <div class="item">
        <span>商城订单发货数：</span>
        <span>{{ statistics_info.shop_send_count || 0 }}</span>
      </div>
    </div>
    <!-- 表格 -->
    <div class="hospital-send-table">
      <el-table
        v-loading="tableLoading"
        :header-cell-style="{ background: '#F5F5F5' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          label="药房名"
          prop="hospital_name"
          align="center"
        ></el-table-column>
        <el-table-column
          label="处方数"
          prop="order_count"
          align="center"
        ></el-table-column>
        <el-table-column
          label="处方发货数"
          prop="send_count"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import kefu from "@/api/kefu";
export default {
  data() {
    return {
      hospitalSendForm: {
        statistics_time: [],
      },
      tableData: [],
      statistics_info: {},
      tableLoading: false,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    // 初始化日期（默认近一周）
    initDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.hospitalSendForm.statistics_time = [
        dayjs(start).format("YYYY-MM-DD"),
        dayjs(end).format("YYYY-MM-DD"),
      ];
    },
    // 获取列表数据
    getList() {
      this.tableLoading = true;
      const times = this.hospitalSendForm.statistics_time;
      const params = {
        start_time: times && times.length ? times[0] : "",
        end_time: times && times.length ? times[1] : "",
      };

      kefu
        .hospitalSend(params)
        .then((res) => {
          const { code, data } = res;
          if (code == 0) {
            this.statistics_info = {
              all_order_count: data.info.all_order_count,
              all_send_count: data.info.all_send_count,
              shop_order_count: data.info.shop_order_count,
              shop_send_count: data.info.shop_send_count,
            };
            this.tableData = data.info.list || [];
          } else {
            this.$message.error(res.message || "获取数据失败");
          }
          this.tableLoading = false;
        })
        .catch((err) => {
          this.$message.error("获取数据失败");
          this.tableLoading = false;
        });
    },
    // 查询
    searchBtn() {
      this.getList();
    },
    // 导出
    exportData() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const times = this.hospitalSendForm.statistics_time;
      const params = {
        start_time: times && times.length ? times[0] : "",
        end_time: times && times.length ? times[1] : "",
      };

      kefu
        .exportHospitalSend(params)
        .then((res) => {
          const { code, data } = res;
          if (code == 0) {
            if (data && data.url) {
              const host = `${document.location.protocol}//${window.location.host}${data.url}`;
              window.open(host);
              this.$message.success("导出成功");
            } else {
              this.$message.error(res.message || "导出失败");
            }
          } else {
            this.$message.error(res.message || "导出失败");
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error("导出失败");
          loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.hospital-send {
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  .data-info {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    .item {
      font-size: 16px;
      font-weight: bold;
      margin: 10px;
    }
  }
  .hospital-send-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .hospital-send-table {
    border: 1px solid #c9cdd6;
  }
}
</style>

